export default {
  documentTitle: 'Management',
  id: 'ID',
  createdAt: 'Created at',
  updatedAt: 'Updated at',
  new: 'New',
  detail: 'Detail',
  edit: 'Edit',
  destroy: 'Destroy',
  operateSuccess: 'Operate Success',
  testerTitleInListPage: 'Tester(only show the testers which create by this platform)',
  suggestSize: 'Suggest size',
  profileInfo: 'Profile',
  createApplication: 'Create application',
  logout: 'Logout',
  choiceRole: 'Choice role',
  miniProgram: 'Mini program',
  waitForBinding: 'Wait for binding',
  waitForWechatAudit: 'The application for registration has been submitted, wait for audit',
  miniProgramRegistrationFail: 'Mini program registration failed, click for more information',
  yesterdayPageView: 'Yesterday page view',
  yesterdayUserView: 'Yesterday user view',
  customPlan: 'Plan',
  standardPlan: 'Standard',
  expired: 'Expired',
  expiredTime: 'The due time is',
  expiredTips: 'Mini program will be closed when plan expired, you can contact customer to upgrade or recharge the plan.',
  contactCustomer: 'Contact customer',
  customerPhone: 'Customer phone',
  customerEmail: 'Customer email',
  longTermEffective: 'Long term effective',
  visitsInTheLastWeek: 'Visits in the last week',
  pageView: 'Page view',
  userView: 'User view',
  noData: 'No Data',
  usersCount: 'Users count',
  membersCount: 'Members count',
  newUserStatistics: 'New user statistics',
  userGenderDistribution: 'User gender distribution',
  userGender: 'User gender',
  userTypeDistribution: 'User type distribution',
  userType: 'User type',
  notAssociatedApplication: 'The current account is not associated with any applications',
  changePassword: 'Change password',
  currentPassword: 'Current password',
  newPassword: 'New password',
  confirmPassword: 'Confirm password',
  error: 'Error',
  pleaseLogin: 'Please login',
  verificationCodeSendSuccessfully: 'Verification code send successfully',
  productsCount: 'Wines count',
  postsCount: 'Posts count',
  messagesCount: 'Messages count',
  unreadMessagesCount: 'Unread messages count',
  count: 'Count',
  unauthorized: 'Unauthorized',
  actions: {
    user: {
      isBlockToTrue: 'Block',
      isBlockToFalse: 'Unblock'
    }
  },
  login: {
    manageSystem: 'Manage System',
    remenberPassword: 'Remember password',
    forgetPassword: 'Forgot password?',
    login: 'Login',
    loginSuccess: 'Login success',
    inputEmail: 'Input email',
    inputPassword: 'Input password',
    confirmNewPassword: 'Confirm new password',
    inputRucaptcha: 'Input captcha',
    resetPassword: 'Reset password',
    resetPasswordSuccess: 'Reset password success',
    sendVeirificationSuccess: 'Verification code has been sent',
    missingLoginName: 'Email is required',
    sendResetPasswordEmailSuccess: 'Reset password email has been sent',
    getResetPasswordEmail: 'Get Reset Password Email',
    signUp: 'Sign up',
    sendVerificationCode: 'Send',
    inputVerificationCode: 'Input code',
    setPassword: 'Input password',
    signIn: 'Sign in',
    signUpSuccess: 'Registered success',
  },
  wechatMiniProgram: {
    analysis: {
      refDate: 'Time',
      sessionCnt: 'Open count',
      visitPv: 'Number of visits',
      visitUv: 'Number of visitors',
      visitUvNew: 'Number of new users',
      stayTimeUv: 'Average stay time per capita',
      stayTimeSession: 'Average stay time per visit',
      visitDepth: 'Average visit depth',
      retentionUvNew: 'Retention of new users',
      retentionUvActive: 'Retention of active users',
      retainedUsers: 'Number of retained users',
      genderAndAge: 'Gender and age',
      platformAndDevice: 'Platform and device',
      portraitOfNewUsers: 'Portrait of new users',
      portraitOfActiveUsers: 'Portrait of active users',
      pagePath: 'Page path',
      pageVisitPv: 'Number of visits',
      pageVisitUv: 'Number of visitors',
      pageStaytimePv: 'Average stay time per visit',
      entrypagePv: 'Number of page entries',
      exitpagePv: 'Number of page exits',
      pageSharePv: 'Number of forwards',
      pageShareUv: 'Number of forwarders',
      retainInfo: 'Retain Info',
      userPortrait: 'User portrait',
      accessSourceSessionCnt: 'Visit source distribution',
      accessStaytimeInfo: 'Visit duration distribution',
      accessDepthInfo: 'Visit depth distribution',
      sourceAnalysis: 'Source analysis',
      gender: 'Gender',
      age: 'Age',
      region: 'Region',
      province: 'Province',
      city: 'City',
      platform: 'Platform',
      device: 'Device',
      yesterday: 'Yesterday',
      latest7Day: 'Latest 7 days',
      latest30Day: 'latest 30 days',
      time: 'Time',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      pleaseSelectDate: 'Please select date',
      pleaseSelectWeek: 'Please select week',
      pleaseSelectMonth: 'Please select month',
      weeklyFormat: 'yyyy week WW',
      timeDayLater: '%{value} day later',
      timeWeekLater: '%{value} week later',
      timeMonthLater: '%{value} month later',
      visitDistribution: 'Visit distribution',
      summaryAndVisitPage: 'Summary and visit page',
      visitTrend: 'Visit trend',
      visitRetain: 'Visit retain',
      visitPage: 'Summary and visit page',
    }
  },
  hint: {
    cannotChangeAfterCreate: 'Can not change after create',
    positionColumn: 'The smaller the value, the higher the priority',
    shareDescLengthHint: 'Maximum of 15 characters',
  },
  menu: {
    productManagement: 'Wine management',
    merchantManagement: 'Winery management',
    eventManagement: 'Event management',
    userManagement: 'User management',
    pageManagement: 'Page management',
    applicationManagement: 'Application management',
    contentManagement: 'Content management',
    homePage: 'Home',
    dataAnalysis: 'Data analysis',
  },
  model: {
    activeStorageBlob: 'Blob'
  },
  activeStorageBlob: {
    filename: 'Filename',
    contentType: 'Content type',
    url: 'Content',
    contentTypes: {
      image: 'Image',
      video: 'Video',
      audio: 'Audio',
      text: 'Text',
      xml: 'XML',
      json: 'JSON',
      pdf: 'PDF',
      sheet: 'Sheet'
    }
  },
  customPage: {
    publish: 'Publish',
    default: 'Preset page',
    preview: 'Preview',
  },
  application: {
    miniProgram: 'Mini program',
    shareDesc: 'Share description',
    wechatOfficialAccountURL: 'Wechat official account URL',
    homeTopLogo: 'Chinese/English logo',
    homeBottomLeftLogo: 'English logo',
    questionaireTopImage: 'Image in the top of questionaire',
    questionaireBackgroundImage: 'Background image of questionaire',
    personalCenterBackgroundImage: 'Background image of personal center',
    myCardsBackgroundImage: 'Background image of my cards',
    wechatApplication: {
      trialSubmition: {
        userVersion: 'Trail version',
        trialVersionQrcode: 'Trail version qrcode',
        userDesc: 'Trail version desc',
      },
      onlineSubmition: {
        userVersion: 'Online version',
        userDesc: 'Online version desc',
      },
      auditSubmition: {
        userVersion: 'Audit version',
        userDesc: 'Audit version desc',
        state: 'Audit state',
        reason: 'Reaseon',
      },
      qrcodeURL: 'Online version wxacode',
    },
    actions: {
      submitAudit: 'Submit audit',
      simulateSubmitAudit: 'Simulate submit audit',
      release: 'Release',
      simulateRelease: 'Simulate release',
      updateExpiredAt: 'Change expired at',
      reauthorization: 'Reauthorization',
      bindMiniProgram: 'Bind mini program'
    },
  },
  page: {
    presetPage: 'Preset page',
  },
  banner: {
    targetUrl: 'Target url',
    targetAppid: 'Targte app id',
  },
  adminUser: {
    password: 'Password',
    passwordConfirmation: 'Password confirmation'
  }
}
